import { Component } from '@angular/core';

@Component({
  selector: 'app-card-border',
  templateUrl: './card-border.component.html',
  styleUrls: ['./card-border.component.scss']
})
export class CardBorderComponent {
	active=false;
	FuncionComponent(){
		if(this.active==false){
			this.active=true;
		}else{
			this.active=false
		}
	}
}
